/**
 * Endpoints — Feedback & suggestions (liste, votes, commentaires, modération).
 */
import { qs } from '../../utils/queryString.js'

export const feedbackEndpoints = {
  list: (params) => `/api/feedbacks${qs(params)}`,
  summary: () => '/api/feedbacks/summary',
  detail: (id) => `/api/feedbacks/${id}`,
  create: () => '/api/feedbacks',
  vote: (id) => `/api/feedbacks/${id}/vote`,
  comments: (id) => `/api/feedbacks/${id}/comments`,
  comment: (id, commentId) => `/api/feedbacks/${id}/comments/${commentId}`,
  uploadImage: () => '/api/feedbacks/upload-image',
}
